module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/crop-6ea1844dfa88eb0b21602defe1db5316.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/crop.svg
// module id = o7XV
// module chunks = 24